import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import _ from 'lodash';
import objectsDeepNotEqualComparison from '~/modules/core/utils/jsHelpers/objectsDeepComparison';
import { LargeSpacer, SmallSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import withRefetchConsumer from '~/modules/core/utils/relayHelpers/withRefetchConsumer';
import { SmallLabel } from '~/modules/coreUI/components/legacies/Labels';
import Rating from '~/modules/ecommerceCoreUI/components/basic/Rating';
import { currentCurrencyDisplayName } from '~/modules/ecommerceCore/utils/changeCurrency';

import FiltersUpdater from '../FiltersUpdaterWrapper';
import TrackFilterElement from './TrackFilterElement';
import ClearAllTracks from './ClearAllTracks';

const LargeSpacerUI = styled(LargeSpacer)`
  display: inline-block;
`;
const SmallSpacerStyle = styled(SmallSpacer)`
  display: inline-block;
`;
const RatingStyle = styled(Rating)`
  display: inline-block;
`;
class TracksFilter extends Component {
  static getDerivedStateFromProps(nextProps, currentState) {
    const nextFiltersProp = nextProps.refetchData && nextProps.refetchData.filters;

    const newPropsReceived = objectsDeepNotEqualComparison(
      currentState.previousFiltersProps,
      nextFiltersProp,
    );

    if (newPropsReceived) {
      return {
        allFilters: _.cloneDeep(nextFiltersProp),
        previousFiltersProps: _.cloneDeep(nextFiltersProp),
      };
    }
    return null;
  }

  state = {
    allFilters: [],
    previousFiltersProps: [], // eslint-disable-line react/no-unused-state
    ratingValuesMapper: {
      four_stars: { label: '4+', value: 4.5 },
      three_stars: { label: '3+', value: 3.5 },
      two_stars: { label: '2+', value: 2.5 },
      one_star: { label: '1+', value: 1.5 },
    },
  };

  filterUpdater = new FiltersUpdater(this.props.refetchMethod);

  onFilterCheckboxClicked = (filterCategoryName, clickedOption) => {
    let allFilters = _.clone(this.state.allFilters);

    allFilters = allFilters.map(
      filter => (filter.name === filterCategoryName
        ? {
          ...filter,
          options: filter.options.map(
            option => (option.name === clickedOption.name ? this.toggledOption(option) : option),
          ),
        }
        : filter),
    );

    this.updateState(allFilters);
  };

  onFilterPricingClicked = (clickedOptionParent) => {
    let allFilters = _.clone(this.state.allFilters);

    allFilters = allFilters.map(filter => ({
      ...filter,
      options: filter.options.map(
        option => (option.selected && option.name === 'min_price'
          ? this.updatePrice(clickedOptionParent, option, 2)
          : this.disableMaxPrice(clickedOptionParent, option)),
      ),
    }));

    this.updateState(allFilters);
  };

  disableMaxPrice = (clickedOptionParent, option) => (option.name === 'max_price' ? this.updatePrice(clickedOptionParent, option, 3) : option);

  updatePrice = (clickedOptionParent, option, number) => ({
    ...option,
    selected: false,
    value: clickedOptionParent.options[number].value,
  });

  handleSelectedTracksCount = (selectedFilterOption) => {
    this.selectedTracks.push(selectedFilterOption);
  };

  toggledOption = option => ({
    ...option,
    selected: !option.selected,
  });

  updateState = (allFilters) => {
    this.setState(
      {
        allFilters,
      },
      () => this.refetchFilters(),
    );
  };

  refetchFilters = () => {
    this.filterUpdater.refetch(this.state.allFilters);
  };

  refetchEmptyFilters = () => {
    this.filterUpdater.refetch([]);
  };

  buildFilterGroupsBasedOnName = filterOption => (filterOption.display_name !== 'price'
    ? this.renderFilter(filterOption.options)
    : this.renderPriceFilter(filterOption));

  buildRenderRatingFilter = filterOption => filterOption.options.map(
    filterOptionItem => filterOptionItem.selected && (
      <React.Fragment key={filterOption.id}>
        {this.handleSelectedTracksCount(filterOptionItem)}
        <TrackFilterElement
          trackName={(
            <React.Fragment>
              <SmallLabel htmlFor={filterOption.name}>
                {this.state.ratingValuesMapper[filterOptionItem.value].label}
              </SmallLabel>
              <SmallSpacerStyle />
              <RatingStyle
                name={filterOptionItem.name}
                rating={this.state.ratingValuesMapper[filterOptionItem.value].value}
              />
            </React.Fragment>
)}
          onClick={() => this.onFilterCheckboxClicked(filterOption.name, filterOptionItem)}
        />
        <LargeSpacerUI />
      </React.Fragment>
    ),
  );

  buildFilterTracksGroups = () => {
    if (!this.state.allFilters) {
      return [];
    }
    this.selectedTracks = [];
    return this.state.allFilters.map((filterOption) => {
      if (filterOption.display_name === 'price') {
        return this.renderPriceFilter(filterOption);
      }
      if (filterOption.name === 'ratings') {
        return this.buildRenderRatingFilter(filterOption);
      }

      return this.renderFilter(filterOption);
    });
  };

  renderFilter = filter => filter.options.map(
    filterOption => filterOption.selected && (
      <React.Fragment>
        {this.handleSelectedTracksCount(filterOption)}
        <TrackFilterElement
          key={filterOption.id}
          trackName={filterOption.name}
          onClick={() => this.onFilterCheckboxClicked(filter.name, filterOption)}
        />
        <LargeSpacerUI />
      </React.Fragment>
    ),
  );

  renderPriceFilter = filterOptionParent => filterOptionParent.options.map(
    filterOption => filterOption.selected
        && filterOption.name === 'min_price' && (
          <React.Fragment key={filterOption.name}>
            {this.handleSelectedTracksCount(filterOption)}
            <TrackFilterElement
              trackName={`${filterOptionParent.options[0].value} ${currentCurrencyDisplayName()} - ${
                filterOptionParent.options[1].value
              } ${currentCurrencyDisplayName()}`}
              onClick={() => this.onFilterPricingClicked(filterOptionParent)}
            />
            <LargeSpacerUI />
          </React.Fragment>
    ),
  );

  render = () => (
    <React.Fragment>
      {this.buildFilterTracksGroups()}
      {this.selectedTracks
        && this.selectedTracks.length > 1 && <ClearAllTracks onClick={this.refetchEmptyFilters} />}
    </React.Fragment>
  );
}

TracksFilter.propTypes = {
  refetchMethod: PropTypes.func.isRequired,
};
export default withRefetchConsumer(TracksFilter);
